<template>
  <div class="date-range-selects row">
    <div class="col-12 col-sm-4 col-xl-3 mb-3">
      <template v-if="checkinLabel">
        <label class="sr-only visually-hidden-focusable" :for="checkinId">{{ checkinLabel }}</label>
      </template>
      <input required v-model="dateRange.startDate"
             @change="updateCheckin"
             @blur="reportValidity"
             :type="timePicker ? 'datetime-local': 'date'"
             ref="inputCheckin"
             name="checkin" class="checkin form-control"
             :aria-labelledby="checkinLabelId"
             :id="checkinId"
             :min="autoMinDate"
             :max="maxDate"
      />
    </div>
    <template v-if="!singleDatePicker">
      <template v-if="checkoutLabel">
        <label class="sr-only visually-hidden-focusable" :for="checkoutId">{{ checkoutLabel }}</label>
      </template>
      <div class="col-12 col-sm-4 col-xl-3 mb-3">
        <input required v-model="dateRange.endDate"
               @change="updateCheckout"
               @blur="reportValidity"
               :type="timePicker ? 'datetime-local': 'date'"
               ref="inputCheckout"
               name="checkout" class="checkout form-control"
               :id="checkoutId"
               :min="autoCheckoutMinDate"
               :max="maxDate"
        />
      </div>
    </template>
    <template v-if="step.duration">
      <div class="col-12 col-sm-4 d-flex mb-3 ps-3 ps-sm-1">
        <output class="duration align-self-center" aria-label="Dauer">{{ step.duration }}</output>
      </div>
    </template>
  </div>

</template>
<script>
import dayjs from 'dayjs'

export default {
  props: {
    idPrefix: String,
    step: Object,
    singleDatePicker: Boolean,
    name: String,
    timePicker: Boolean,
    isDiverse: Boolean,
    datePickerText: String,
    checkinLabelId: String,
    checkinLabel: String,
    checkoutLabel: String,
    minDate: String,
    maxDate: String,
    nights: Number,
  },
  data() {
    return {
      userHasSelected: false,
      ranges: false,
      dateRange: {
        startDate: this.step.checkin,
        endDate: this.step.checkout,
      },
      currentDurationDays: null,
    }
  },
  created() {
    this.currentDurationDays = this.calcDurationDays
  },
  computed: {
    autoMinDate() {
      const dates = [dayjs()];
      if (this.minDate) {
        dates.push(dayjs(this.minDate));
      }
      return this.maxDateFromArray(dates)
    },
    autoCheckoutMinDate() {
      const dates = [dayjs()];
      if (this.minDate) {
        dates.push(dayjs(this.minDate));
      }
      if (this.dateRange.startDate) {
        dates.push(dayjs(this.dateRange.startDate))
      }
      return this.maxDateFromArray(dates)
    },
    checkinId() {
      if (this.checkinLabelId) {
        return null
      }
      return `step${this.step._index}_${this.idPrefix}_checkin`
    },
    checkoutId() {
      return `step${this.step._index}_${this.idPrefix}_checkout`
    },
    calcDurationDays() {
      if (!this.dateRange.startDate || !this.dateRange.endDate) {
        return
      }
      return dayjs(this.dateRange.endDate).diff(dayjs(this.dateRange.startDate), 'day')
    },
  },
  methods: {
    maxDateFromArray(dates) {
      const maxDate = dates.reduce((a, b) => (a.isAfter(b) ? a : b));
      return maxDate.format('YYYY-MM-DD');
    },
    reload() {
      this.dateRange.startDate = this.step.checkin
      this.dateRange.endDate = this.step.checkout
    },
    updateCheckin() {
      if (this.dateRange.startDate) {
        // use duration set from checkout or use default nights
        this.currentDurationDays ||= this.nights || 1
        this.dateRange.endDate = dayjs(this.dateRange.startDate).add(this.currentDurationDays, 'day').format('YYYY-MM-DD')
      }
      this.updateInputs()
    },
    updateCheckout() {
      this.currentDurationDays = this.calcDurationDays
      if (this.dateRange.endDate && this.nights) {
        this.dateRange.startDate = dayjs(this.dateRange.endDate).add(-this.nights, 'day').format('YYYY-MM-DD')
      }
      this.updateInputs()
    },
    reportValidity() {
      if (!this.$refs.inputCheckin.checkValidity()) {
        this.$refs.inputCheckin.reportValidity()
        return
      }
      if (this.$refs.inputCheckout && this.dateRange.endDate) {
        this.$refs.inputCheckout?.reportValidity()
      }
    },
    updateInputs() {
      if (this.isDiverse) {
        this.step.setDates(this.$store, this.name, this.singleDatePicker, this.dateRange.startDate, this.dateRange.endDate);
        this.$parent.validateOption(this.name);
      } else {
        this.step.setDates(this.$store, this.dateRange.startDate, this.dateRange.endDate);
        this.$parent.handleDatePicker(true);
      }
    }
  }
}
</script>